<template>
  <div class="home">
    <!-- <h2 class="qjc-texta-c">订单统计</h2> -->
    <div class="charts_wrap">
      <div class="user_wrap">
        <div class="charts_title">最近一年用户注册数据统计</div>
        <div class="user_echarts"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { getStatistics } from "@/utils/axios"

export default {
  name: 'mainOrderCharts',
  data () {
    return {
      userInfo: {},
    }
  },
  mounted () {
    if (localStorage.getItem('userInfo')) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.handleLoad()
    }
  },
  methods: {
    handleLoad () {
      getStatistics({ act: '1year' }).then((res) => {
        if (res.code == 200) {
          let result = JSON.parse(window.atob(res.data))
          this.handleUserCharts(result.date, result.num)
        }
      })
    },
    handleUserCharts (date, num, amount, cash) {
      var option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return '月份：' + params[0].name + '<br>' + params[0].seriesName + '：' + params[0].value

          }
        },
        legend: {
          show: true,
          data: ['用户数'],
          icon: 'round',
          textStyle: {
            color: '#777F8F',
            fontSize: 12
          },
          top: 0,
          left: '45%',
          itemHeight: 2,
          itemWidth: 20,
          itemGap: 6,
          zlevel: 100,
        },
        grid: {
          left: '5%',
          right: '3%',
          bottom: '10%',
          top: '10%'
        },
        xAxis: {
          // boundaryGap: false,
          axisLabel: {
            color: '#777F8F',
            interval: 0
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: 'true',
            lineStyle: {
              color: '#f5f5f5'
            }
          },
          data: date
        },
        yAxis: {
          name: '',
          type: 'value',
          axisLabel: {
            color: '#777F8F'
          },
          minInterval: 1,
          max: function (value) {
            return Math.ceil(value.max) + 50;
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#f5f5f5'
            }
          }
        },
        series: [
          {
            type: 'bar',
            name: '用户数',
            barWidth: 30,
            data: num
          }
        ],
        color: ['#6883FB']
      };
      this.drawChat('.user_echarts', option);
    },

    drawChat (el, option) {
      window[el] = echarts.init(document.querySelector(el));
      // option.animationDuration = 1000;
      window[el].setOption(option, true);
      window.onresize = window[el].resize;
    },// 绘制图表通用
  },
}
</script>

<style lang="scss" scoped>
.home {
  padding: 30px 40px;
}

.home-wrap {
  padding: 40px;
  // border-bottom: 1px solid #dddddd;
}

.home-cell {
  font-size: 15px;
  margin-bottom: 10px;

  span {
    margin-right: 20px;
  }
}

.home-bottom {
  text-align: center;
  margin-top: 40px;
  font-size: 12px;
  padding-top: 20px;
  border-top: 1px solid #dddddd;
}

.charts_wrap {}

.charts_title {
  font-size: 20px;
  color: #333;
}

.user_echarts {
  width: 100%;
  height: 450px;
  margin-bottom: 40px;
}

.order_echarts {
  width: 100%;
  height: 450px;
}
</style>
